var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-h4"},[_vm._v("Solicitudes")]),_c('RequestList',{attrs:{"requests":_vm.requests}}),_c('v-pagination',{attrs:{"length":_vm.pages,"value":_vm.currentPage},on:{"input":_vm.changePage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }